<template>
  <BaseBottomSheet ref="dialog" @close="$emit('close')">
    <div class="w-full p-8 gap-8 flex flex-col bg-white rounded-t-xl shadow-xl">
      <!-- Header Section -->
      <div
        ref="header"
        class="w-full gap-2 flex flex-col items-center justify-center text-center"
      >
        <BaseIcon icon="user-gear" class="text-4xl text-primary" />
        <span class="text-3xl font-semibold text-gray-900">
          {{ $t('hub.exercises.settingsModal.title') }}
        </span>
      </div>

      <!-- Body Section -->
      <div class="gap-6 flex flex-col text-center text-gray-700">
        <!-- Language Select -->
        <div class="gap-4 flex flex-col">
          <BaseLanguageSelect
            :value="explanationLanguage"
            :label="$t('hub.exercises.settingsModal.explanationLanguage')"
            :placeholder="
              $t('hub.exercises.settingsModal.explanationLanguagePlaceholder')
            "
            icon="globe"
            @input="v => (explanationLanguage = v)"
          />
        </div>
        <!-- Settings -->
        <div class="gap-4 flex flex-col">
          <div class="flex items-center justify-between p-4">
            <div class="flex flex-col items-start text-left">
              <span class="font-medium text-gray-900">
                {{
                  $t('hub.exercises.settingsModal.isCorrectAnswerExplanations')
                }}
              </span>
            </div>
            <BaseSwitch v-model="isCorrectAnswerExplanations" />
          </div>
        </div>

        <!-- Action Button -->
        <div class="mt-6 flex justify-center">
          <BaseButton @click="handleClose">
            {{ $t('hub.exercises.settingsModal.save') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </BaseBottomSheet>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import BaseBottomSheet from '@/components/Base/BaseBottomSheet.vue'
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'
import BaseSwitch from '@/components/Base/BaseSwitch.vue'
import BaseLanguageSelect from '@/components/Base/BaseLanguageSelect.vue'

export default {
  name: 'HubExercisesSettingsModal',

  components: {
    BaseButton,
    BaseBottomSheet,
    BaseIcon,
    BaseSwitch,
    BaseLanguageSelect
  },

  computed: {
    ...mapState('exercises', ['settings']),

    isCorrectAnswerExplanations: {
      get() {
        return this.settings.isCorrectAnswerExplanations
      },
      set(value) {
        this.setIsCorrectAnswerExplanations(value)
      }
    },

    explanationLanguage: {
      get() {
        return this.settings.explanationLanguage
      },
      set(value) {
        this.setExplanationLanguage(value)
      }
    }
  },

  methods: {
    ...mapMutations('exercises', {
      setIsCorrectAnswerExplanations: 'SET_IS_CORRECT_ANSWER_EXPLANATIONS',
      setExplanationLanguage: 'SET_EXPLANATION_LANGUAGE'
    }),

    handleClose() {
      this.$refs.dialog.handleClose()
    }
  }
}
</script>
